module.exports = __webpack_public_path__ + "static/media/gasQuestion.236542ec.png";